import {FC, SVGProps} from 'react';
import type {ProfileDocumentIcon} from '../../model/profileDocuments';

type IconProps = SVGProps<SVGSVGElement>;

const PassportIcon: FC<IconProps> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M30 23L16.0039 30H15.9961L2 23V2L15.9961 9H16.0039L30 2V23ZM23 13C21.3431 13 20 14.3431 20 16C20 17.6569 21.3431 19 23 19C24.6569 19 26 17.6569 26 16C26 14.3431 24.6569 13 23 13Z"
			fill="black"
		/>
	</svg>
);

const InnIcon: FC<IconProps> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15 3.03851C12.7811 3.20968 10.6373 3.9483 8.77759 5.19089C6.63975 6.61935 4.97351 8.64967 3.98957 11.0251C3.00563 13.4006 2.74819 16.0144 3.2498 18.5362C3.75141 21.0579 4.98953 23.3743 6.80762 25.1924C8.6257 27.0105 10.9421 28.2486 13.4638 28.7502C15.9856 29.2518 18.5995 28.9944 20.9749 28.0104C23.3503 27.0265 25.3807 25.3603 26.8091 23.2224C28.0517 21.3627 28.7903 19.2189 28.9615 17H15V3.03851Z"
			fill="black"
		/>
		<path
			d="M17 2C18.7072 2 20.3977 2.33625 21.9749 2.98957C23.5521 3.64288 24.9852 4.60045 26.1924 5.80761C27.3996 7.01477 28.3571 8.44788 29.0104 10.0251C29.6638 11.6023 30 13.2928 30 15H17V2Z"
			fill="black"
		/>
	</svg>
);

const ICONS: Record<ProfileDocumentIcon, FC<IconProps>> = {
	passport: PassportIcon,
	inn: InnIcon,
};

export const ProfileDocumentIconView: FC<{name: ProfileDocumentIcon; className?: string}> = ({name, className}) => {
	const Icon = ICONS[name];
	return <Icon className={className} aria-hidden />;
};
